import React, { useEffect, useRef, useState } from 'react';
import { NetworkIcon, XIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { settingsActions } from '../../data/settingsStore';
type CatalogDrawerProps = {
  onClose: () => void;
};
export function CatalogDrawer({
  onClose
}: CatalogDrawerProps) {
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    inputRef.current?.focus();
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [onClose]);
  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (!name.trim()) {
      setError('Department name is required.');
      return;
    }
    settingsActions.addDepartment(name.trim());
    onClose();
  };
  return <div className="fixed inset-0 z-[100] flex justify-end" role="presentation" data-id="element-269" data-mp="13kzooda8ll3o">
      <button type="button" onClick={onClose} className="absolute inset-0 cursor-default bg-slate-900/40 backdrop-blur-sm" aria-label="Close add department form" data-id="element-270" data-mp="16i8yk4f9erdt" />
      <motion.aside initial={{
      x: '100%'
    }} animate={{
      x: 0
    }} exit={{
      x: '100%'
    }} transition={{
      type: 'tween',
      duration: 0.25,
      ease: [0.32, 0.72, 0, 1]
    }} className="relative flex h-full w-full max-w-xl flex-col bg-white shadow-2xl" role="dialog" aria-modal="true" aria-labelledby="catalog-drawer-title" data-id="element-271" data-mp="xkykkbb24o57">
        <div className="flex items-start justify-between border-b border-slate-100 p-6" data-id="element-272" data-mp="1gh877n00yn0t">
          <div className="flex items-start gap-3" data-id="element-273" data-mp="1ki0g2f4zipwk">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-slate-100 text-[#14466B]" data-id="element-274" data-mp="288xk75qjgix9">
              <NetworkIcon className="h-5 w-5" data-id="element-275" data-mp="2d05s1xc7zw8b" />
            </span>
            <div data-id="element-276" data-mp="2d1qjvf75h12h">
              <h2 id="catalog-drawer-title" className="text-xl font-bold text-slate-900" data-id="element-277" data-mp="2mvmix5cyus2l">
                Add department
              </h2>
              <p className="mt-1 text-sm text-slate-500" data-id="element-278" data-mp="2iv2gpndjcy9l">
                Create a department for organising your operations.
              </p>
            </div>
          </div>
          <button type="button" onClick={onClose} className="rounded-full p-2 text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-600" aria-label="Close add department form" data-id="element-279" data-mp="28wd0dz1aflvg">
            <XIcon className="h-5 w-5" data-id="element-280" data-mp="1z4qos1l1fks6" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="flex flex-1 flex-col overflow-y-auto" data-id="element-281" data-mp="1v587dfsfdru3">
          <div className="space-y-5 p-6" data-id="element-282" data-mp="1q6etvnd520tx">
            <label className="block text-sm font-medium text-slate-700" data-id="element-283" data-mp="1q395kacc32z9">
              Department name <span className="text-rose-600" data-id="element-284" data-mp="1l5hf7krc7ox6">*</span>
              <input ref={inputRef} value={name} onChange={event => {
              setName(event.target.value);
              setError('');
            }} placeholder="e.g. Project Delivery" className={`mt-1.5 w-full rounded-lg border bg-white px-3 py-2.5 text-sm text-slate-700 outline-none focus:ring-2 ${error ? 'border-rose-300 focus:border-rose-400 focus:ring-rose-100' : 'border-slate-200 focus:border-blue-400 focus:ring-blue-100'}`} aria-invalid={Boolean(error)} data-id="element-285" data-mp="1g6w9j5tbgd1c" />
              {error && <span className="mt-1 block text-xs font-normal text-rose-600" data-id="element-286" data-mp="scvz3twet4zb">{error}</span>}
            </label>
          </div>
          <div className="mt-auto flex items-center justify-end gap-3 border-t border-slate-100 bg-slate-50 p-6" data-id="element-287" data-mp="x9cp6tn65tf1">
            <button type="button" onClick={onClose} className="rounded-lg border border-slate-200 bg-white px-4 py-2.5 text-sm font-medium text-slate-700 transition-colors hover:bg-slate-50" data-id="element-288" data-mp="123qkyx5qu2k8">
              Cancel
            </button>
            <button type="submit" className="rounded-lg bg-[#14466B] px-4 py-2.5 text-sm font-medium text-white shadow-sm transition-colors hover:bg-[#0F3D5C]" data-id="element-289" data-mp="2ba8y6h4h05nm">
              Save department
            </button>
          </div>
        </form>
      </motion.aside>
    </div>;
}